var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{ref:"header",staticClass:"bubbles-header",class:{'selected-border': _vm.selected},style:(_vm.style),on:{"click":_vm.updateStoryPath}},[_vm._v(" "+_vm._s(_vm.details.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }